module.exports = __webpack_public_path__ + "img/BY.74dc1ef6.png";